import { request } from './request'

export const listCustomerBillVatByCustomerNamePopUp = (params) =>
  request({
    url: `/api/customer_bill_vat/customer_name/list`,
    method: 'get',
    params: params ?? null,
  })